import * as yup from 'yup';

import { useYupValidators } from '~/utils/yupValidators';

const useMobileMoneyPaymentSchema = () => {
  const yupValidators = useYupValidators();
  const mobileMoneyPaymentSchema = yup.object().shape({
    // phoneNumber: yupValidators.phoneNumber,
    phoneNumber: yupValidators.numberExpressUnion,
    indicatif: yupValidators.indicatifExpressUnion,
  });

  return { mobileMoneyPaymentSchema };
};

export { useMobileMoneyPaymentSchema };
